/**
 * Styled Components - Created by david on 20/02/18.
 */
import styled from 'styled-components'
import { WHITE, DARK_TEXT } from '../../theme/colors'

export const Regions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  cursor: pointer;

  @media (max-width: 1099px) {
    height: 40px;
    img {
      max-width: 18px;
    }
  }
`

export const Option = styled.div`
  display: flex;
  align-items: center;
`

export const MenuOption = styled.div`
  color: #5f6062;
  margin-left: 12px;
  font-size: 14px;
  line-height: 22px;
`

export const menuStyle = {

}

type ThemeProps = {
  darkMode: boolean
}

export const TopText = styled.div`
  color: ${({ darkMode }: ThemeProps) =>
  darkMode ? WHITE : DARK_TEXT};
  font-size: 14px;
  cursor: pointer;
`

export const overStyle = {
  width: 276,
  paddingTop: 7
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MenuRegion/styledComponents.tsx